<dialog #dialogRef qai-dialog [heading]="heading" [description]="description" [showClose]="false">
  <div class="gender-form">
    <qai-label
      class="gender-label"
      [kind]="'secondary'"
      [size]="'small'"
      [weight]="'regular'"
    >
      {{ dropdownLabel }}
    </qai-label>
    <qai-floating-select
      [options]="genderOptions"
      [placeholder]="placeholder"
      [placement]="'below-start'"
      [shape]="'rectangle'"
      [value]="selectedValue"
      (valueChange)="onValueChange($event)"
    />
    <div
      *ngIf="message && selectedValue && message[selectedValue]"
      class="gender-message"
    >
      {{ message[selectedValue] }}
    </div>
    <button
      type="button"
      class="gender-confirm-btn"
      qai-button
      [kind]="'primary'"
      [size]="'large'"
      (click)="onConfirm()"
    >
      {{ buttonText }}
    </button>
  </div>
</dialog>
